/**
 * The basis a listing extra (add-on) is charged on. Quantity multiplies all of
 * them: two firewood bundles "per night" is price × nights × 2.
 */
export type ExtraUnit = 'stay' | 'night' | 'person';

export const EXTRA_UNITS: ExtraUnit[] = ['stay', 'night', 'person'];

/**
 * The unit an extra is actually charged on. A null `unit` is a row saved before
 * the column existed, or by the legacy apps, which never send one: those keep the
 * old rule that extra parking and tents are per night and everything else is per
 * stay — which is also what the legacy apps quote.
 */
export function effectiveExtraUnit(extra: { label?: string; unit?: ExtraUnit | null }): ExtraUnit {
  if (extra.unit) {
    return extra.unit;
  }

  return extra.label === 'extraParking' || extra.label === 'extraTent' ? 'night' : 'stay';
}
